import * as React from 'react';
import { connect } from 'react-redux';
import { Box } from '../../CommonUI/Layout';
import { css, StyleSheet } from 'aphrodite';
import { Text as T } from 'ilenia';
import { PastOrders, ConfigurationScope } from '../../Model';

const invitationsUrl = process.env.REACT_APP_InvitationHistoryUrl;

interface PastOrdersSummaryProps {
    source?: string;
    tierName?: string;
    pastOrders?: PastOrders;
    configurationScopeTree?: ConfigurationScope[];
}

class PastOrdersSummary extends React.Component<PastOrdersSummaryProps> {
    constructor(props: PastOrdersSummaryProps) {
        super(props);

        this.onInvitationsLinkClick = this.onInvitationsLinkClick.bind(this);
        this.renderShopList = this.renderShopList.bind(this);
    }

    public renderShopList(shops?: string[]) {
        const { configurationScopeTree } = this.props;
        if (shops && configurationScopeTree) {
            const shopNames = shops
                .map((ids: string) => ids.split(','))
                .map((ids: string[]) => configurationScopeTree.find((scope) => this.arraysEqual(scope.ids, ids)))
                .filter((scope: ConfigurationScope | undefined) => scope !== undefined)
                .map((scope: ConfigurationScope) => `${scope.names.store}${scope.names.view ? '-' + scope.names.view : ''}`);
            if (shopNames.length > 1) {
                return (
                    <div className={css(styles.list)}>
                        <ul>
                            {shopNames.map((shop, i) => (
                                <li key={`${shop}-${i}`}>
                                    {shop}
                                </li>
                            ))}
                        </ul>
                    </div>
                );
            }
        }
        return null;
    }

    public onInvitationsLinkClick() {
        const { source, tierName } = this.props;
        analytics.track('Integration Link Clicked', {
            context: 'Ecommscript integration app',
            location: window.location.pathname,
            integration: source,
            placement: 'Under past orders summary',
            target: 'Invitations B2B page',
            name: 'link-navigate-to-invitations',
            tierName,
        });
        window.open(invitationsUrl, '_blank');
    }

    public render() {
        const { pastOrders } = this.props;
        if (!pastOrders) {
            return null;
        }
        const { shops } = pastOrders;
        return (
            <Box className={css(styles.box)}>
                <div className={css(styles.container)}>
                    <div className={css(styles.title)}>
                        <T id="enhancedPastOrders.summaryTitle" />
                    </div>
                    {this.renderShopList(shops)}
                </div>
                <div className={css(styles.link)} onClick={this.onInvitationsLinkClick}>
                    <T id="enhancedPastOrders.checkStatus" />
                </div>
            </Box>
        );
    }

    private arraysEqual(arr1: string[], arr2: string[]) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = arr1.length; i--;) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    }
}

const mapStateToProps = (state: any) => ({
    source: state.App.source,
    tierName: state.App.tierName,
    pastOrders: state.PastOrders.pastOrders,
    configurationScopeTree: state.App.configurationScopeTree,
});

export default connect(mapStateToProps, null)(PastOrdersSummary);

const styles = StyleSheet.create({
    container: {
    },
    box: {
        maxWidth: '558px',
        background: 'rgb(253, 253, 253)',
        borderRadius: '4px',
        height: '100%',
        marginTop: 0,
        marginBottom: '0px',
        padding: '0px',
        borderTop: 'none',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    title: {
        color: 'rgb(34, 34, 34)',
        fontSize: '16px',
        fontWeight: 'bold',
        letterSpacing: '0px',
        margin: '0 auto 16px',
    },
    list: {
        color: 'rgb(83, 83, 83)',
        fontSize: '14px',
        fontWeight: 'normal',
        letterSpacing: '0px',
        padding: '16px 0px 24px 0px',
    },
    link: {
        color: 'rgb(54, 140, 215)',
        fontSize: '14px',
        fontWeight: 'normal',
        letterSpacing: '0px',
        lineHeight: '20px',
        margin: '24px auto 0',
        cursor: 'pointer',
    },
});
